module.exports = __webpack_public_path__ + "img/1F618.0db07f3f.svg";